/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { BetaFeature, isBetaFeatureEnabled } from '@zcode/nr-utils'
import * as Api from '@zcode/nr/es/shared/api/index'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Dispatch } from '../../../types'
import { setRentReport } from '../../actions/hashtagModal'

export const loadRentReport = () => async (dispatch: Dispatch) => {
  try {
    dispatch(
      setRentReport(
        await Api.rentReport.get({
          draft: isBetaFeatureEnabled(dispatch(getRouteProps()).location, BetaFeature.DRAFT),
        })
      )
    )
  } catch (e: unknown) {
    console.error(e)
    dispatch(setRentReport(null))
  }
}
